export const HubspotDetailedFeatures = [
    {
        "tab_heading":"CRM / Lead Management",
        "tab_info":[
            {
                "name":"Lead Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"1-click Property portals integration - auto lead capture",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Configurable Pipeline Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Custom Fields",
                "realtor":"Yes",
                "type":"Only in Higher Plans"
            },
            {
                "name":"Team Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Full Hierarchy Management",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Omnichannel Communication",
        "tab_info":[
            {
                "name":"Integrated Cloud telephony with IVR, complex routing, intelligent sticky routing",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"International & India Support Across Key Telephony providers",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Toll Free Numbers Availability - India & International",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Full Call Centre Software",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Support for On-Premise Telephony Set up",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integrated Email Communication with Delivery, Open, Click Tracking",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integrated SMS & Short-code Support",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integrated WhatsApp For Business Support (with full Automation like MakeMyTrip)*",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integrations with Live Chat Software",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Integrations with FB Messenger",
                "realtor":"Partial",
                "type":"Yes"
            },
            {
                "name":"Integrations with Chat bots",
                "realtor":"Partial",
                "type":"Yes"
            },
            {
                "name":"Automated Outbound Dialer",
                "realtor":"Y (upgrade possible for multiple call center spots)",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Sales Automation",
        "tab_info":[
            {
                "name":"Workflow Management - Automate lead & sales management",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Fully configurable Lead Scoring Algo developed with 10 years of industry Experience",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Intelligent Lead Routing - based on Project, Team, Geo, Campaign, Source, sub source",
                "realtor":"Yes",
                "type":"Partial"
            },
            {
                "name":"Sales Targets & Reports",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Asset management - Images, brochures, quotes, files",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Automated Responders - Email + SMS + WhatsApp",
                "realtor":"Yes",
                "type":"Y (No WhatsApp)"
            },
            {
                "name":"Booking Form with Support for Agreement + Brokerage Calculations",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Customizable sales UI - Forms, Booking form, etc",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Automated click to call function",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Fully Integrated IVR",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Site Visit Feedback Forms",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Insta Connect - For Instant Auto connected Call back to Customers",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Escalation Matrix & Risk Identification",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Channel Partner Management (Channel Partner Module)",
        "tab_info":[
            {
                "name":"Full Support for Channel Partner Onboarding",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Broadcast Messages & Offers to Partners",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Partner Lead Tracking",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Allow Partners to take bookings, with cheque/payment collections",
                "realtor":"Y (with IRIS)",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Negotiation & Price Quote Management",
        "tab_info":[
            {
                "name":"Create & Track Price Quotes",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Schemes & Discounts",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Approval Workflow for Discounts",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Payment Schedule & Cost Sheet Calculator",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"PDF Generator for Payment Schedule & Cost Calculator",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Marketing Automation (Marketing Module)",
        "tab_info":[
            {
                "name":"Campaign Management",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"ROI Calculations",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Campaign Targets & Tracking/Reports",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Connected Facebook Adverts Tracking - Auto CPL calculations & Dashboards",
                "realtor":"Yes",
                "type":"Steep Pricing under Marketing License"
            },
            {
                "name":"Connected Awards Tracking - Auto CPL calculations & Dashboards",
                "realtor":"Yes",
                "type":"Steep Pricing under Marketing License"
            },
            {
                "name":"Offline Budget & CPL Tracking - Outdoor, Print, BTL, Portals",
                "realtor":"Yes",
                "type":"Steep Pricing under Marketing License"
            },
            {
                "name":"Drip Marketing",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Automated tracking of website, live chat, and any lead input channel",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Missed Calls Campaigns",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Short Code Integration",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Outbound Call Campaigns",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Completely customizable Website builder - with free templates - comes with a free project microsite",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Auto Integrates with Google Analytics and e-commerce",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Bulk Email Marketing",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Bulk SMS Marketing",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Facebook Lead Generation Ads - Auto Lead Capture",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Look Alike Audience Management with Awards & Facebook",
                "realtor":"Yes",
                "type":"Steep Pricing under Marketing License"
            }
        ]
    },
    {
        "tab_heading":"Product & Inventory",
        "tab_info":[
            {
                "name":"Inventory management - projects, towers, configurations and units",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Costs & Cost Sheet Calculator at Unit Level",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Inventory Pipeline Management - Blocking of Premium Inventory",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Support for Sale, Resale, Rental Inventory",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integration with leading ERPs (SAP, Dynamics, Farvision)",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Post Sales (Post Sales Module)",
        "tab_info":[
            {
                "name":"Complete Demand Letter Generation",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Payment Reminders",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Fully configurable payment schedules & Ad-Hoc Costs",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Cancellations & Upgrades",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Manage Parking Inventory",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Booking to Agreement to Possession Automation & Tracking",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Ledger & Outstanding",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Interest Calculations & Demand",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Receipts & Payment Collection",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integrated Post Sales Communication - Email, SMS, WhatsApp",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integrated Workflow Automation",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Inventory Movement Report",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Recovery & Ageing Report",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Risk Identification & Automated Escalations",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Reporting & Dashboards",
        "tab_info":[
            {
                "name":"Sales Reports",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Lead Pipeline Reports",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Calling & Call Centre Reports",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Funnel and Cohort analysis",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Analytics platform with funnel customer journey mapping and real time reporting",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Lead Re-Engagement reports",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Reports for online, offline, by channel (google, fb, print, outdoor), by medium (phone, email, website, etc)",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Full Visitor Behaviour Analytics",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Customized MIS Reports",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Customer Management (IRIS)",
        "tab_info":[
            {
                "name":"Customer Access & Online Interface",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Online Bookings, Schemes & Discounts",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Referral & Loyalty Program",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Online Payments",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Project Launch & EOI Support",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Channel Partner Management",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Channel Partners can take bookings & collect Payments",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Cancellation & Swap Support",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Ticketing Support for Customers",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Mobile App (No Extra Charges)",
        "tab_info":[
            {
                "name":"Sales Management Android & iOS App",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"GPS Tracking",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Inventory Management Support",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"OTP Based Meeting Verification",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"GPS Based Meeting Verification",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Offline Call Tracking with Recording",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Data Security",
        "tab_info":[
            {
                "name":"ISO 27001 Certified Data Security & Compliance",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Camouflaged Communication - No exposure of customer's phone/email data to anyone except the admin",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Full VAPT Compliance",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"GDPR Compliance",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Data security - Complete Sandboxed and Encrypted data on the Cloud",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    }
];
export default HubspotDetailedFeatures;
